export enum PointsErrors {
  Valid = "",
  InvalidNumber = "rewards.errors.invalidNumber",
  BelowMinimum = "rewards.errors.belowMinimum",
  GreaterThanTotalBalance = "rewards.errors.numberGreaterThanTotalBalance",
  GreaterThanTotalCost = "rewards.errors.numberGreaterThanTotalCost",
}

export type PointsErrorValidationResult = {
  isValid: boolean;
  reason: PointsErrors;
};

export const validatePointsInput = (
  appliedPoints: number | undefined,
  minimumRedemptionPoints: number,
  maxPoints: number | undefined,
  isFixedPrice = false
): PointsErrorValidationResult => {
  if (appliedPoints == null || appliedPoints <= 0) {
    return { isValid: true, reason: PointsErrors.Valid };
  }

  if (maxPoints != null && appliedPoints > maxPoints) {
    return { isValid: false, reason: PointsErrors.GreaterThanTotalCost };
  }

  // Skip minimum validation for grid bookings (fixed price)
  // User already met minimum with fixed points purchase
  if (!isFixedPrice && appliedPoints < minimumRedemptionPoints) {
    return { isValid: false, reason: PointsErrors.BelowMinimum };
  }

  return { isValid: true, reason: PointsErrors.Valid };
};
